export default {
    intro: 'Hãy sắp xếp các câu bị xáo trộn theo đúng thứ tự!',
    indicator: ({ values }: { values: { isAllDone: boolean } }) => {
        const { isAllDone } = values;
        if (isAllDone) { return 'Hãy đọc lại bài viết đã hoàn thành.'; }
        return 'Hãy sắp xếp thứ tự các câu cho đúng!';
    },
    table: { question: 'Câu hỏi', answerRate: 'Độ chính xác', emptyMessage: 'Không có nội dung.' },
    roundNumber: 'Số {number}',
};
